import type * as Types from '../../types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import document from './rootPlaceBySlugQuery.gql';
import type * as ApolloReactCommon from '~/lazy_apollo/client';
import * as ApolloReactHooks from '~/lazy_apollo/client';
const defaultOptions = {} as const;
export type RootPlaceBySlugQuery_rootPlace_RootPlace_menuItems_MenuItemPaginationHandler_records_MenuItem_featuredPhoto_MenuItemPosPhoto = {
  __typename: 'MenuItemPosPhoto',
  id: number,
  photoUrl?: string | null
};

export type RootPlaceBySlugQuery_rootPlace_RootPlace_menuItems_MenuItemPaginationHandler_records_MenuItem_featuredPhoto_Photo = {
  __typename: 'Photo',
  id: number,
  photoUrl?: string | null
};

export type RootPlaceBySlugQuery_rootPlace_RootPlace_menuItems_MenuItemPaginationHandler_records_MenuItem_featuredPhoto =
  | RootPlaceBySlugQuery_rootPlace_RootPlace_menuItems_MenuItemPaginationHandler_records_MenuItem_featuredPhoto_MenuItemPosPhoto
  | RootPlaceBySlugQuery_rootPlace_RootPlace_menuItems_MenuItemPaginationHandler_records_MenuItem_featuredPhoto_Photo
;

export type RootPlaceBySlugQuery_rootPlace_RootPlace_menuItems_MenuItemPaginationHandler_records_MenuItem_location_RestaurantLocation = {
  __typename: 'RestaurantLocation',
  id: number,
  city: string,
  countryName: string,
  state?: string | null
};

export type RootPlaceBySlugQuery_rootPlace_RootPlace_menuItems_MenuItemPaginationHandler_records_MenuItem_restaurant_Restaurant = {
  __typename: 'Restaurant',
  id: number,
  name: string
};

export type RootPlaceBySlugQuery_rootPlace_RootPlace_menuItems_MenuItemPaginationHandler_records_MenuItem = {
  __typename: 'MenuItem',
  id: number,
  displayName: string,
  idAsSlug: string,
  popsCount: number,
  featuredPhoto?: RootPlaceBySlugQuery_rootPlace_RootPlace_menuItems_MenuItemPaginationHandler_records_MenuItem_featuredPhoto | null,
  location?: RootPlaceBySlugQuery_rootPlace_RootPlace_menuItems_MenuItemPaginationHandler_records_MenuItem_location_RestaurantLocation | null,
  restaurant: RootPlaceBySlugQuery_rootPlace_RootPlace_menuItems_MenuItemPaginationHandler_records_MenuItem_restaurant_Restaurant
};

export type RootPlaceBySlugQuery_rootPlace_RootPlace_menuItems_MenuItemPaginationHandler = {
  __typename: 'MenuItemPaginationHandler',
  count: number,
  hasMore: boolean,
  offset: number,
  records: Array<RootPlaceBySlugQuery_rootPlace_RootPlace_menuItems_MenuItemPaginationHandler_records_MenuItem>
};

export type RootPlaceBySlugQuery_rootPlace_RootPlace = {
  __typename: 'RootPlace',
  id: number,
  name: string,
  slug: string,
  menuItems: RootPlaceBySlugQuery_rootPlace_RootPlace_menuItems_MenuItemPaginationHandler
};

export type RootPlaceBySlugQuery_Query = {
  __typename?: 'Query',
  rootPlace: RootPlaceBySlugQuery_rootPlace_RootPlace
};


export type RootPlaceBySlugQueryVariables = Types.Exact<{
  pagination: Types.PaginationInput;
  slug: Types.Scalars['String']['input'];
  dishCategory?: Types.InputMaybe<Types.MenuItemDishCategory>;
}>;


export type RootPlaceBySlugQuery = RootPlaceBySlugQuery_Query;


export const RootPlaceBySlugDocument = /*#__PURE__*/ document as unknown as DocumentNode<RootPlaceBySlugQuery, RootPlaceBySlugQueryVariables>;


/**
 * __useRootPlaceBySlugQuery__
 *
 * To run a query within a React component, call `useRootPlaceBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useRootPlaceBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRootPlaceBySlugQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      slug: // value for 'slug'
 *      dishCategory: // value for 'dishCategory'
 *   },
 * });
 */
export function useRootPlaceBySlugQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RootPlaceBySlugQuery, RootPlaceBySlugQueryVariables> & ({ variables: RootPlaceBySlugQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RootPlaceBySlugQuery, RootPlaceBySlugQueryVariables>(RootPlaceBySlugDocument, options);
      }
export function useRootPlaceBySlugLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RootPlaceBySlugQuery, RootPlaceBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RootPlaceBySlugQuery, RootPlaceBySlugQueryVariables>(RootPlaceBySlugDocument, options);
        }
// @ts-ignore
export function useRootPlaceBySlugSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RootPlaceBySlugQuery, RootPlaceBySlugQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RootPlaceBySlugQuery, RootPlaceBySlugQueryVariables>;
export function useRootPlaceBySlugSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RootPlaceBySlugQuery, RootPlaceBySlugQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RootPlaceBySlugQuery | undefined, RootPlaceBySlugQueryVariables>;
export function useRootPlaceBySlugSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RootPlaceBySlugQuery, RootPlaceBySlugQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RootPlaceBySlugQuery, RootPlaceBySlugQueryVariables>(RootPlaceBySlugDocument, options);
        }
export type RootPlaceBySlugQueryHookResult = ReturnType<typeof useRootPlaceBySlugQuery>;
export type RootPlaceBySlugLazyQueryHookResult = ReturnType<typeof useRootPlaceBySlugLazyQuery>;
export type RootPlaceBySlugSuspenseQueryHookResult = ReturnType<typeof useRootPlaceBySlugSuspenseQuery>;
export type RootPlaceBySlugQueryResult = ApolloReactCommon.QueryResult<RootPlaceBySlugQuery, RootPlaceBySlugQueryVariables>;